module.exports = __webpack_public_path__ + "img/scheepsbrug-oplossing.dc481159.png";